import {GitHubAvatar} from '@github-ui/github-avatar'
import {Box, Link, Octicon} from '@primer/react'
import {graphql, useFragment} from 'react-relay'

import type {EventActorAvatarItemBadge$key} from './__generated__/EventActorAvatarItemBadge.graphql'
import {userHovercardPath} from '@github-ui/paths'
import {PersonIcon} from '@primer/octicons-react'
import {VALUES} from '../../constants'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'

type EventActorAvatarItemBadgeProps = {
  actor: EventActorAvatarItemBadge$key | null
  largeAvatar?: boolean
} & SharedProps

type EventActorAvatarItemBadgeInternalProps = {
  actor: EventActorAvatarItemBadge$key
  largeAvatar?: boolean
} & SharedProps

type SharedProps = {
  highlighted: boolean
  leadingIconOnTop?: boolean
}

// TO DO LOOK AT THIS CASE HERE
export function EventActorAvatarItemBadge({actor, ...props}: EventActorAvatarItemBadgeProps): JSX.Element {
  return actor ? (
    <EventActorAvatarInternal actor={actor} {...props} />
  ) : (
    <Octicon icon={PersonIcon} size={VALUES.timeline.badgeSize} />
  )
}

function EventActorAvatarInternal({actor, ...props}: EventActorAvatarItemBadgeInternalProps): JSX.Element {
  const {login, avatarUrl} = useFragment(
    graphql`
      fragment EventActorAvatarItemBadge on Actor {
        avatarUrl(size: 64)
        login
      }
    `,
    actor,
  )

  const highlightedStyle: BetterSystemStyleObject = props.highlighted
    ? {
        borderRadius: '50%',
        boxShadow: `0px 0px 0px 2px var(--color-accent-fg), 0px 0px 0px 4px var(--color-accent-subtle)`,
        height: props.largeAvatar ? 24 : 16,
        width: props.largeAvatar ? 24 : 16,
      }
    : {}

  const adjustedStyle: BetterSystemStyleObject = props.leadingIconOnTop ? {marginTop: '4px'} : {}

  const elementStyle = {
    ...highlightedStyle,
    ...adjustedStyle,
  }

  return (
    <Box {...props} sx={{...elementStyle}}>
      <Link sx={{display: 'flex'}} href={`/${login}`} data-hovercard-url={userHovercardPath({owner: login})}>
        <GitHubAvatar src={avatarUrl} size={props.largeAvatar ? 24 : 16} />
      </Link>
    </Box>
  )
}

try{ EventActorAvatarItemBadge.displayName ||= 'EventActorAvatarItemBadge' } catch {}
try{ EventActorAvatarInternal.displayName ||= 'EventActorAvatarInternal' } catch {}